<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import Qs from 'qs'
  import { Message, MessageBox } from "element-ui"
  import URL from '@/views/crs36/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import axios from 'axios'

  let pattern = {1: "手动更新", 2: "自动更新"};
  let status = {1: "启用", 2: "禁用"};
  let statusButton = {2: "启用", 1: "禁用"};
  let dataSource = {"newCrs": "旧CRS库", "mis": "新MIS库", "master": "新CRS库"};
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      checkbox(row){
        this.deleteIds = row.map(key => key.id).join(",");
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
          if (clickName == "modify") {
              this.$refs.childUpdate.open(row);
          } else if (clickName == "switch") {
              let status = (row.status == 1 ? 2 : 1);
              this.$axios.get(URL.ceGroup.open, {
                  params: {id: row.id, status: status}
              }).then((res) => {
                  if (res.code == 0) {
                      this.$refs.childTable.defaultGetData(this.queryData);
                      this.$message.success(window.$t('mis.faceConfig.updateSuccess'))
                  } else {
                      this.$message.error(res.message);
                  }
              }).catch(function (error) {
                  console.log(error);
              });
          } else if (clickName == "update") {
              this.$axios.post(URL.ceGroup.synGroupUserList, Qs.stringify({groupId: row.id})).then((res) => {
                  if (res.code == 0) {
                      this.$refs.childTable.defaultGetData(this.queryData);
                      this.$message.success(window.$t('mis.faceConfig.updateSuccess'))
                  } else {
                      this.$message.error(res.message);
                  }
              }).catch(function (error) {
                  console.log(error);
              });
          } else if (clickName == "detail") {
              //跳转到详情页
              this.$router.push({path:"/crs36/pushMsg/ceGroupUser",query:{groupId:row.id,label:"CRS36"}});
          }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultQueryData(data);
        }else if("新增" == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        this.dataChanage(URL.ceGroup.save,model,res => {
          if (res.code == 0){
          this.$refs.childUpdate.close();
          this.$message.success("提交成功");
        }else{
          this.$message.success("提交失败");
        }
      })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {

        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      },
      validationData(model){
          this.dataChanage(URL.ceGroup.validationData,model,res => {
              if (res.code == 0) {
                  this.$message.success("验证通过");
              } else {
                  this.$message.success("验证不通过");
              }
          });
      }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
                        { title: 'id', field: 'id',hidden:true},
                        { title: '分群名称', field: 'cname'},
                        { title: '分群别名', field: 'name'},
                        { title: '更新方式', field: 'pattern',type:3,optionList:pattern,isNumber:true},
                        { title: '数据源', field: 'dataSource',type:2,optbtnionList:dataSource},
                        { title: '分群规则', field: 'rules',textType:'textarea',btn:"验证数据",click:(model,col)=>{
                                             this.validationData(model);
                            }},
                        { title: '状态', field: 'status',type:3,optionList:status,isNumber:true},
                      ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
                          { title: '分群名称', field: 'cname'},
                          { title: '分群别名', field: 'name'},
                          {click: window.$t('mis.bt.query')},
                          {click: window.$t('mis.bt.add')}
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.ceGroup.list, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
                          { title: '分群名称', field: 'cname'},
                          { title: '分群别名', field: 'name'},
                          { title: '用户人数', field: 'userCount'},
                          { title: '创建人', field: 'creator'},
                          { title: '创建时间', field: 'createDate'},
                          { title: '更新人', field: 'updater'},
                          { title: '更新时间', field: 'updateDate'},
                          { title: '状态', field: 'status', render: (data, full) => {
                                  return status[data] || "";
                              }},
                          {
                              title: window.$t('mis.bt.operation'),width:380, btnClick: [
                                  {name: window.$t('mis.bt.edit'), click: "modify", type: "primary", icon: "el-icon-edit"},
                                  {name: "详情", click: "detail", type: "primary", icon: "el-icon-edit"},
                                  {
                                      name: (data, full) => {
                                          return statusButton[full.status];
                                      }, click: "switch", type: "primary", icon: "el-icon-edit"
                                  },
                                  {name: "更新", click: "update", type: "primary", icon: "el-icon-delete",hidden: (data, full) => {
                                          return (full.pattern==2)?true:false;
                                      }}]
                          },
          ]
        }
      }
    }
  }
</script>
